(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("KarcherReportsViewModel", karcherReportsViewModelFactory);

  /** @ngInject */
  function karcherReportsViewModelFactory(
    DateTime,
    $translate
  ) {
    function KarcherReportsViewModel() {
      var that = this;

      // Date for time zone of selected facility
      this.chartData = {
        data: null,
        x: {
          type: "timeseries",
          tick: {
            culling: { max: 15 },
            rotate: 60,
            multiline: true,
            format: function (item) {
              switch (that.selectedTimeFrame) {
                case "HOURLY":
                  return moment.tz(item, that.facilityTimeZone).format("DD/MM/YY HH:mm");
                case "DAILY":
                  return moment.tz(item, that.facilityTimeZone).format("DD/MM/YY");
                case "WEEKLY":
                  that.chartData.x.type = 'x';
                  return item;
                case "MONTHLY":
                  return moment.tz(item, that.facilityTimeZone).format("MM/YY");
                case "YEARLY":
                  return moment.tz(item, that.facilityTimeZone).format("YYYY");
              }
            }
          }
        },
        y: {
          tick: {
            rotate: 60
          }
        }
      };
      this.facilityTimeZone = "";
      this.reportFrom = null;
      this.reportTo = null;
      this.washFacilityList = [];
      this.selectedWashFacility = "";
      this.placeHolderText = $translate.instant("FACILITY_NAME");
      this.selectedReport = "";
      this.selectedTimeFrame = "HOURLY";
      this.isChartVisible = false;
      this.subPointList = [];
      this.timeFrameList = ["HOURLY", "DAILY", "WEEKLY", "MONTHLY", "YEARLY"];
      this.weatherHistoryData = [];
      this.weatherLocationData = [];
      this.reportNameList = [
        {
          id: 1,
          name: $translate.instant('KARCHER_REPORT_1')
        },
        {
          id: 2,
          name: $translate.instant('KARCHER_REPORT_2')
        },
        {
          id: 3,
          name: $translate.instant('KARCHER_REPORT_3')
        },
        {
          id: 4,
          name: $translate.instant('KARCHER_REPORT_4')
        },
        {
          id: 5,
          name: $translate.instant('KARCHER_REPORT_5')
        },
        {
          id: 6,
          name: $translate.instant('KARCHER_REPORT_6')
        },
        {
          id: 7,
          name: $translate.instant('KARCHER_REPORT_7')
        },
        {
          id: 8,
          name: $translate.instant('KARCHER_REPORT_8')
        },
        {
          id: 9,
          name: $translate.instant('KARCHER_REPORT_9')
        },
        {
          id: 10,
          name: $translate.instant('KARCHER_REPORT_10')
        }
      ];

      this.reportFrom = new Date(
        new DateTime().startOf(DateTime.units.MONTH).timestamp
      );
      this.reportTo = new Date(
        new DateTime().endOf(DateTime.units.DAY).timestamp
      );
    }

    KarcherReportsViewModel.prototype.destroy = function () {};

    KarcherReportsViewModel.prototype.refreshKarcherReportsData = function (
      data
    ) {
      this.chartData.data = data;
      this.isChartVisible = this.chartData.data.total !== 0;
    };

    KarcherReportsViewModel.prototype.refreshWeatherHistoryData = function (
        data
    ) {
      this.weatherHistoryData = data.forecast.forecastday;
      this.weatherLocationData = data.location;
    };

    KarcherReportsViewModel.prototype.refreshWashFacilityList = function (
      data
    ) {
      this.washFacilityList = data;
    };

    KarcherReportsViewModel.prototype.refreshSubPointList = function (data) {
      this.subPointList = data;
    };

    KarcherReportsViewModel.prototype.getTimezoneForSelectedFacility = function (selectedFacility) {
      this.facilityTimeZone = selectedFacility[0].timeZone;
    };

    return KarcherReportsViewModel;
  }
})();
